import {Injectable} from '@angular/core';
import {HttpRequestService } from '../../shared/services/http-request.service';
import 'rxjs/add/operator/map';
import {environment} from '../../../environments/environment';
import {GridService} from '../../shared/services/grid.service';

@Injectable()
export class EventDatabaseService extends GridService {
  private getEventsURL = environment.apiUrl + '/EventCms/GetEvents';

  constructor(private _http: HttpRequestService) {
    super();
    this.getData = this.getEvents;
  }

  getEvents(data) {
    return this._http.post(this.getEventsURL, data);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/event-database.service.ts